import React from 'react';

export type CurrencyProps = {
  amount: number;
};

export function Currency(props: CurrencyProps) {
  const { amount } = props;
  return (
    <span>
      {amount?.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      })}
    </span>
  );
}
